export const SITE_ORIGIN =
  import.meta.env.VITE_SITE_URL || 'https://cssspreadsheetbr.com';

export const SITE_NAME = 'CSSSpreadsheetBR';

export const SITE_LOGO_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

export const SITE_OG_IMAGE =
  'https://readdy.ai/api/search-image?query=Fashion%20ecommerce%20flat%20lay%20with%20sneakers%2C%20hoodies%2C%20denim%2C%20caps%20and%20accessories%20arranged%20as%20a%20creative%20overhead%20grid%20on%20a%20warm%20cream%20textured%20background%2C%20soft%20directional%20lighting%2C%20editorial%20streetwear%20product%20photography%2C%20earthy%20neutral%20beige%20and%20olive%20tones%2C%20high%20detail%2C%20balanced%20airy%20composition&width=1600&height=900&seq=hero-bg-v2&orientation=landscape';